// extracted by mini-css-extract-plugin
export default {"filesTabContainer":"Files_filesTabContainer__Yhiqh","filesListContainer":"Files_filesListContainer__XzCHn","emptyText":"Files_emptyText__liu2l"};